/**
 * Generate UUID v4
 */
export function generateUUID(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export interface Session {
  sessionId: string;
  startTime: number;
  getCompletionTime: () => number;
}

export function createSession(): Session {
  return {
    sessionId: generateUUID(),
    startTime: Date.now(),
    getCompletionTime: function() {
      const elapsed = Math.floor((Date.now() - this.startTime) / 1000);
      // Cap at 900 seconds (15 minutes)
      return Math.min(elapsed, 900);
    }
  };
}




